export default __webpack_public_path__ + "static/media/pdrrmc_seal.97714b71.png";